module.exports = __webpack_public_path__ + "static/media/img.62f62218.zip";